import React from 'react';

import Button from 'components/Button';
import './styles.css';

const Buttons = ({triggerSubmit, submitting, submitButtonDisabled}) => (
  <div className="Buttons">
    <Button
      onClick={triggerSubmit}
      blue={!submitButtonDisabled}
      isLoading={submitting}
      disabled={submitButtonDisabled}>
      Apply schedule
    </Button>
  </div>
);

export default Buttons;
